import { IGoal } from "motw_core/Entity/IGoal";
import * as React from "react";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import Glyphicon from "source/app/presentation/Shared/Glyphicon/Glyphicon";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import { GetGoalTimeDetails } from "source/app/services/Time/GoalTime/GoalTimeDetails";
import * as moment from "moment";

export function ShowTimeLight({
    goal,
    hasGoodStreak,
}: {
    goal: IGoal;
    hasGoodStreak: boolean;
}) {
    const isGoalLoggedToday = hasGoodStreak;
    const goalTimeDetails = GetGoalTimeDetails(goal.name, moment());

    if (goalTimeDetails.isGoalNameTimeValid === false) {
        return <InvalidGoalNameTime />;
    }

    const shouldDisplayIcon =
        !isGoalLoggedToday &&
        (goalTimeDetails.isActive || goalTimeDetails.isNotStartedYet);

    if (!shouldDisplayIcon) {
        return null;
    }

    return goalTimeDetails.isNotStartedYet ? (
        <GoalNotStartedIcon />
    ) : (
        <ValidGoalNameTime />
    );
}

function GoalNotStartedIcon() {
    const styleClass = StyleClass(`showGoalNotStartedIcon`, {
        position: "absolute",
        fontSize: "8px",
        color: "gold",
        left: "3px",
        opacity: 0.6,
    });

    return (
        <span className={styleClass}>
            <Glyphicon icon={EGlyphicon.glass} />
        </span>
    );
}

function ValidGoalNameTime() {
    const styleClass = StyleClass(`showTimeLight`, {
        position: "absolute",
        fontSize: "8px",
        color: "gold",
        left: "3px",
        opacity: 0.6,
    });

    return (
        <span className={styleClass}>
            <Glyphicon icon={EGlyphicon["circle-arrow-down"]} />
        </span>
    );
}

function InvalidGoalNameTime() {
    const styleClass_Error = StyleClass(`showTimeLight_Error`, {
        position: "absolute",
        fontSize: "8px",
        color: "coral",
        left: "3px",
        opacity: 0.6,
    });

    return (
        <span
            className={styleClass_Error}
            data-tip={`Goal name time is in an invalid format`}
        >
            <Glyphicon icon={EGlyphicon.remove} />
        </span>
    );
}
